export default {
  name: 'Slim Banner Bottom Web Push Notifications',
  htmlId: 'slimBannerBottomWPN',
};
